/*
  The come o;ver hero (sections/come-over-hero.liquid): every 5s the stage takes the next past
  night's colour tokens (data-tones, "~"-separated declarations) and names it (data-names). The
  header over it follows, as on home. stage-canvas.js watches the stage's style attribute and eases
  the gradient. Still under reduced motion; paused while the hero is off screen or the tab is hidden.
*/
if (!customElements.get('come-over-hero')) {
  customElements.define(
    'come-over-hero',
    class ComeOverHero extends HTMLElement {
      static STEP_MS = 5000;

      connectedCallback() {
        this.tones = (this.dataset.tones || '').split('~');
        this.names = (this.dataset.names || '').split('~');
        this.label = this.querySelector('[data-hero-name]');
        this.header = document.querySelector('.section-header');
        this.index = 0;
        this.visible = true;
        if (this.tones.length < 2) return;
        this.paint(0);
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.view = new IntersectionObserver(([entry]) => {
          this.visible = entry.isIntersecting;
          this.schedule();
        });
        this.view.observe(this);
        this.onVisibility = () => this.schedule();
        document.addEventListener('visibilitychange', this.onVisibility);
        this.motion.addEventListener('change', this.onVisibility);
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        this.view?.disconnect();
        document.removeEventListener('visibilitychange', this.onVisibility);
        this.motion?.removeEventListener('change', this.onVisibility);
      }

      schedule() {
        clearTimeout(this.timer);
        if (!this.visible || document.hidden || this.motion.matches) return;
        this.timer = setTimeout(() => {
          this.index = (this.index + 1) % this.tones.length;
          this.paint(this.index);
          this.schedule();
        }, ComeOverHero.STEP_MS);
      }

      // The night's tokens on the stage and the header; its name in the line.
      paint(index) {
        const declarations = this.tones[index]
          .split(';')
          .map((part) => part.split(':').map((side) => side.trim()))
          .filter(([name, value]) => name && value && name.startsWith('--'));
        [this, this.header].forEach((element) => {
          if (!element) return;
          declarations.forEach(([name, value]) => element.style.setProperty(name, value));
        });
        if (this.label && this.names[index]) this.label.textContent = this.names[index];
        const canvas = this.querySelector(':scope > stage-canvas');
        requestAnimationFrame(() => canvas?.recolour?.());
      }
    }
  );
}
